export default __webpack_public_path__ + "static/media/Legal_CommonMenu.584daf3c.svg";